<script>
import ArchivedOrderAPI from "@/services/archivedOrders-api";
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
       
        pagemodelMain: {currentPage : 1, perPage : 10, totalRows: 0},

        archivedOrderList:[],
        searchInput:null,
        searchByTableNumber:null,
        isArchivedOrderTableBusy:false,
        start:null,
        end:null,

        archivedOrderListFields: 
            [
                { key:"order", label: "",thClass:"text-left ",tdClass:"text-left"},
                { key:"type", label: "",thClass:"text-left ",tdClass:"text-left"},
                { key:"count", label: "",thClass:"text-center ",tdClass:"text-center font-weight-bold"},
                { key:"total", label: "",thClass:"text-right ",tdClass:"text-right font-weight-bold font-size-14"},
                // { key:"customer", label: "",   sortable: false, tdClass:""},
            ],

        firstSelected: true,

   
      }
      
    },

    
  computed:{
      ...mapGetters('menu', ['menuCampaignId']),

    isMobile() {
      return window.innerWidth <= 768;
    }
  },

    
  mounted() {
    this.findArchivedOrder()
  },

  methods: {

    initPagination(){
        this.pagemodelMain= {currentPage : 1, perPage : 10, totalRows: 0}
    },

    onSelectedTableNumber(selectedItems) {
      this.firstSelected = false;
      const selectedRow = selectedItems[0] || null
      this.$emit('update:selectedTableNumber', selectedRow)
    },

    findArchivedOrder(){
        this.isArchivedOrderTableBusy = true;
        ArchivedOrderAPI.findArchivedOrder(this.pagemodelMain.currentPage,
                                            this.pagemodelMain.perPage,
                                            this.start ,
                                            this.end ,
                                            this.searchInput,
                                            this.menuCampaignId,
                                            this.searchByTableNumber).then(
                response => {
                    if(response) {
                    this.archivedOrderList= response.list
                    this.pagemodelMain.totalRows = response.total;
                    this.pagemodelMain.currentPage = response.page;
                    this.pagemodelMain.perPage = response.pageSize;
                    this.pagemodelMain.pageSize = response.pageSize;

                    if (this.archivedOrderList.length > 0 && !this.isMobile) {
                      this.firstSelection = true;
                      this.$emit('update:selectedTableNumber', this.archivedOrderList[0]);
                    }

                  }   
                }
            )
            .finally(() => {
            this.isArchivedOrderTableBusy = false;
      });
    },


  },

  watch: {

      start: function(){
          this.initPagination(); 
          this.findArchivedOrder()
      },

      end: function(){
        this.initPagination(); 
        this.findArchivedOrder()
      },

      menuCampaignId: function(){
          this.findArchivedOrder()
      },
  }



};
</script>

<template>

<div>
  
      <h2 class="card-title font-size-25 text-dark text-uppercase" style="font-size:25px;">{{$t('archivedOrder.cardTitle')}} </h2>
      
      <div >

        <div  class="row mt-4">
          <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-1 ">
            <b-form-group :label="$t('datPicker.startDate.label-no-date-selected')"  label-for="">
              <b-form-datepicker
                v-model="start"
                locale="fr"
                size="sm"                      
                class="p-1"                    
                label-no-date-selected="Date Début"
                reset-button
                close-button
                label-reset-button="Réinitialiser"
                label-close-button="Fermer"
                dropright
                hide-header
              ></b-form-datepicker>
            </b-form-group>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pl-lg-3">
            <b-form-group :label="$t('datPicker.endDate.label-no-date-selected')"  label-for="">
              <b-form-datepicker
                v-model="end"
                locale="fr"
                size="sm"                     
                class="p-1"
                label-no-date-selected="Date Fin"
                reset-button
                close-button
                label-reset-button="Réinitialiser"
                label-close-button="Fermer"
                dropright
                hide-header
              ></b-form-datepicker>
            </b-form-group>
          </div>
        </div>
        
        <div class="row">
          <div class ="col-md-4 col-12 mr-md-2 mr-0">
            <b-form-group :label="$t('archivedOrder.input.searchInput.label')" >
                <b-input-group  >
                    <b-form-input :placeholder="$t('archivedOrder.input.searchInput.placeholder')"   v-model="searchInput"   @keyup.native.enter="findArchivedOrder() "
                    @keyup.enter="initPagination(); findArchivedOrder()" ></b-form-input>                              
                    <template v-slot:append>
                        <b-button variant="primary" @click="initPagination(); findArchivedOrder()" >
                        <i class="bx bx-search-alt font-weight-bold font-size-16 text-white align-middle"></i>
                        </b-button>
                    </template>
                </b-input-group>
            </b-form-group>
          </div>
          <div class ="col-md-4 col-12 ml-md-2 ml-0">
            <b-form-group :label="$t('archivedOrder.input.searchByTableNumber.label')" >
                <b-input-group  >
                    <b-form-input :placeholder="$t('archivedOrder.input.searchByTableNumber.placeholder')"   v-model="searchByTableNumber"   @keyup.native.enter="findArchivedOrder() "
                    @keyup.enter="initPagination(); findArchivedOrder()" ></b-form-input>                              
                    <template v-slot:append>
                        <b-button variant="primary" @click="initPagination(); findArchivedOrder()" >
                        <i class="bx bx-search-alt font-weight-bold font-size-16 text-white align-middle"></i>
                        </b-button>
                    </template>
                </b-input-group>
            </b-form-group>
          </div>
        </div>
        


        <div class="table-responsive mt-3"> 
          <b-table
          ref="archivedTable"
            selectable
            select-mode="single"
            :busy="isArchivedOrderTableBusy"
            striped
            :items="archivedOrderList"
            :fields="archivedOrderListFields"
            :per-page="pagemodelMain.perPage"
            class="table align-middle archived-order-table"
            :class="this.firstSelected ? 'b-table-row-selected' : ''"

            @row-selected="onSelectedTableNumber"
          >
            <template #table-busy>
              <div class="text-center my-3">
                <b-spinner variant="primary" />
              </div>
            </template>

            <template #head(order)>
              {{ $t("archivedOrder.table.head.date") }}
            </template>

            <!-- <template #head(customer)>
              {{ $t("archivedOrder.table.head.customer") }}
            </template> -->

            <template #head(type)>
              {{ $t("archivedOrder.table.head.type") }}
            </template>

            <template #head(count)>
              {{ $t("archivedOrder.table.head.items") }}
            </template>

            <template #head(total)>
              {{ $t("archivedOrder.table.head.total") }}
            </template>



            <template #cell(order)="{ item }">
              <div class="d-flex flex-column">

                <div class="font-weight-bold text-dark">
                  {{ item.timeStamp }}
                </div>

                <div v-if="item.tableNumber < 100000" class="font-weight-bold text-primary">
                  Table
                  {{ item.tableNumber }}
                </div>

              </div>
            </template>

            <template #cell(type)="{ item }">
              <b-badge
                pill
                :variant="item.tableNumber > 100000 ? 'warning' : 'primary'"
                class="px-3 font-size-12"
              >
                <i
                  :class="item.tableNumber > 100000 ? 'fas fa-globe' : 'fas fa-chair'"
                  class="mr-1"
                ></i>
                {{
                  item.tableNumber > 100000
                    ? $t('archivedOrder.type.online')
                    : $t('archivedOrder.type.onsite')
                }}
              </b-badge>
            </template>

            <template #cell(customer)="{ item }">
              <div class="d-flex flex-column">

                <div v-if="!item.name && !item.phone && !item.mail">-</div>
                <div v-if="item.name" class="font-weight-bold text-dark">
                  <i class="fas fa-user mr-1"></i>
                  {{ item.name }}
                </div>

                <small v-if="item.phone" class="text-muted">
                  <i class="fas fa-phone mr-1"></i>
                  {{ item.phone }}
                </small>

                <small v-if="item.mail">
                  <i class="fas fa-envelope mr-1"></i>
                  {{ item.mail }}
                </small>

              </div>
            </template>

          </b-table>

          <span v-if="!isArchivedOrderTableBusy & !archivedOrderList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("subscription.table.empty")}}</span>
        </div>
        <!-- Pagination -->
        <div class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="findArchivedOrder()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }}</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodelMain.currentPage" :disabled="isArchivedOrderTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findArchivedOrder()" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
        

      </div>


</div>
</template>


<style scoped>

::v-deep .b-table-row-selected tbody tr:first-child {
  background-color: #D4AF37;
  color: #000;
}

</style>